export { default } from './text'
export type { Props as TextProps } from './text'
